import React from 'react';

import { RENDER_MODE as RM } from 'shared/constants/slate';
import { codeMark } from 'shared/styles';

import { cx, css } from 'helpers';


const HeaderPlaceholder = () => (
  <div
    className="absolute top-0 moon-light-gray pointer-events-none"
    contentEditable={false}
  >
    Header
  </div>
);

const headingClass = css({
  '& code': {
    ...codeMark,

    // Make it look good inside heading
    fontSize: '18px',
  },
});


export const Heading = props => {
  const { attributes, children, node, renderMode } = props;
  const level = node.data.get('level');

  const hasPlaceholder =
    node.isEmpty
    && renderMode === RM.RENDER_FOR_EDIT

  const Tag = `h${level}`;

  return (
    <Tag
      className={cx('relative', '-heading-base', headingClass)}
      style={{
        // Let MediumRareEditor define spacing.
        fontSize: '22px',
      }}
      {...attributes}
    >
      {children}

      {hasPlaceholder && <HeaderPlaceholder />}
    </Tag>
  );
};



// WEBPACK FOOTER //
// ./src/components/slate/nodes/heading.js